import { OK } from '../../configs/serverStatusCodes';

export const IMAGE_STORAGE_UNAVAILABLE_MESSAGE = 'Хранилище изображений временно недоступно';

export const applyViolationImagesResponse = (violation, status, responseBody = {}) => {
  if (status === OK) {
    return {
      ...violation,
      photo_url: responseBody.data || violation.photo_url,
    };
  }

  return {
    ...violation,
    photo_url: [],
    photo_error: responseBody.message || IMAGE_STORAGE_UNAVAILABLE_MESSAGE,
  };
};
